/** Rótulos e estilos do fluxo analista — prova objetiva / redação */

export const examObjectiveStatusLabel = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'pending') return '⏳ Prova objetiva atribuída';
  if (s === 'analyzing') return '📝 Prova objetiva em correção';
  if (s === 'completed') return '✅ Nota objetiva lançada';
  if (s === 'returned') return '↩️ Prova objetiva devolvida';
  return '—';
};

export const examEssayStatusLabel = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'pending') return '⏳ Redação atribuída';
  if (s === 'analyzing') return '📝 Redação em correção';
  if (s === 'completed') return '✅ Redação corrigida';
  if (s === 'returned') return '↩️ Redação devolvida';
  return '—';
};

export const examStatusStyle = (status) => {
  const s = (status || '').toLowerCase();
  const base = {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  };
  if (s === 'pending') return { ...base, backgroundColor: '#FEF3C7', color: '#92400E' };
  if (s === 'analyzing') return { ...base, backgroundColor: '#DBEAFE', color: '#1D4ED8' };
  if (s === 'completed') return { ...base, backgroundColor: '#D1FAE5', color: '#166534' };
  if (s === 'returned') return { ...base, backgroundColor: '#FEE2E2', color: '#991B1B' };
  return { ...base, backgroundColor: '#F3F4F6', color: '#6B7280' };
};

export const getExamAssignmentStatus = (app, taskType) => {
  if (taskType === 'essay') return app?.exam_essay_assignment_status || '';
  return app?.exam_objective_assignment_status || '';
};

export const isExamTaskCompleted = (app, taskType) => {
  const s = getExamAssignmentStatus(app, taskType).toLowerCase();
  if (s === 'completed') return true;
  if (taskType === 'essay') {
    return app?.exam_essay_score != null || app?.essay_eliminated;
  }
  return app?.exam_final_score != null && (getExamAssignmentStatus(app, 'objective') || '').toLowerCase() === 'completed';
};

export const canAnalyzeExamTask = (app, taskType) => {
  const s = getExamAssignmentStatus(app, taskType).toLowerCase();
  return s === 'analyzing' || s === 'completed';
};
